import { createContext, useState } from "react";

export const InvoiceContext = createContext();
const InvoiceProvider = ({children}) =>{
    const [invoices,setInvoices] = useState([]);
    const [selectedInvoiceSummary,setSelectedInvoiceSummary] = useState(null);
    const [selectedInvoice,setSelectedInvoice] = useState(null);
    return(
        <InvoiceContext.Provider value={{
            invoices,setInvoices,
            selectedInvoiceSummary,setSelectedInvoiceSummary,
            selectedInvoice,setSelectedInvoice
        }}>{children}</InvoiceContext.Provider>
    );
};
export default InvoiceProvider;